export const permissionConfig = {
    entityName: 'ADMINISTRATOR.PERMISSION.TITLE',
    name: 'ADMINISTRATOR.PERMISSION.NAME',
    description: 'ADMINISTRATOR.PERMISSION.DESCRIPTION'
};